import { j as r } from "./jsx-runtime.js";
import { o as i, u as m } from "./index3.js";
import { u as h } from "./useLinkData.js";
import { b as l } from "./utils.js";
import "react";
import "./index4.js";
import "./util.js";
import "./index2.js";
import "./index5.js";
import "./LinkDataProvider.js";
function S({
  className: t,
  linkStyle: o = "learnMore"
}) {
  const { tck: s } = h(), a = "https://www.mongodb.com/products/platform/atlas-vector-search", e = (n) => /* @__PURE__ */ r.jsx(m, { href: l(a, { tck: s }), hideExternalIcon: !0, children: n.children }), c = () => {
    switch (o) {
      case "learnMore":
        return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          "Powered by Atlas Vector Search.",
          " ",
          /* @__PURE__ */ r.jsx(e, { children: "Learn More." })
        ] });
      case "text":
        return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          "Powered by ",
          /* @__PURE__ */ r.jsx(e, { children: "Atlas Vector Search" })
        ] });
    }
  };
  return /* @__PURE__ */ r.jsx(i, { className: t, children: /* @__PURE__ */ r.jsx(c, {}) });
}
export {
  S as PoweredByAtlasVectorSearch
};
